import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/components/icon/icon.module';

import { SharedModule } from '../../shared/shared.module';
import { HeaderSpaceBetweenComponent } from './header-space-between.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [CommonModule, ButtonModule, IconModule, SharedModule],
  declarations: [HeaderSpaceBetweenComponent],
  exports: [HeaderSpaceBetweenComponent],
})
export class HeaderSpaceBetweenModule {}
